import { all } from "redux-saga/effects";
// Import sagas as they are created
import libraryCardSaga from "./libraryCardSaga";

export default function* rootSaga() {
  yield all([
    libraryCardSaga(),
    // Add more sagas as needed (revenue lines, products, etc.)
  ]);
}
